import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ChatHistory, ChatResponse, OrchestrationSession } from '../../interface/orchestration-assistant.interface';
import { BridgeService } from '../bridge/bridge.service';

@Injectable({
    providedIn: 'root',
})
export class OrchestrationAssistantService {
    constructor(private _bridge: BridgeService) {}

    /**
     * Create a new orchestration assistant session
     * @returns Observable<OrchestrationSession>
     */
    createSession(): Observable<OrchestrationSession> {
        return this._bridge.createOrchestrationSession();
    }

    /**
     * Send a chat message to the orchestration assistant
     * @param sessionId - The session ID
     * @param message - The message to send
     * @returns Observable<ChatResponse>
     */
    sendMessage(sessionId: string, message: string): Observable<ChatResponse> {
        return this._bridge.sendOrchestrationMessage(sessionId, message);
    }

    /**
     * Fetch list of past sessions
     * @returns Observable<any[]>
     */
    getSessions(): Observable<any[]> {
        return this._bridge.getOrchestrationSessions();
    }

    /**
     * Fetch chat history for a session
     * @param sessionId - The session ID
     * @returns Observable<ChatHistory>
     */
    getHistory(sessionId: string): Observable<ChatHistory> {
        return this._bridge.getOrchestrationHistory(sessionId);
    }

    /**
     * Delete an orchestration assistant session
     * @param sessionId - The session ID
     * @returns Observable<void>
     */
    deleteSession(sessionId: string): Observable<void> {
        return this._bridge.deleteOrchestrationSession(sessionId);
    }

    /**
     * Check health status of orchestration assistant service
     * @returns Observable<any>
     */
    checkHealth(): Observable<any> {
        return this._bridge.checkOrchestrationHealth();
    }
}
